import { createFileRoute } from "@tanstack/react-router";
import { Batch } from "@/fla/Batch";

export const Route = createFileRoute("/_app/fla/batches/$batchId")({
  component: RouteComponent,
});

function RouteComponent() {
  const { batchId } = Route.useParams();
  return <Batch batchId={batchId} />;
}
